module.exports = __webpack_public_path__ + "static/img/msg.a341840b.png";